import React, { useState, useEffect, useCallback } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";

import { Link, useNavigate } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PhoneInput, { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'

import 'react-international-phone/style.css';
import { useDispatch, useSelector } from 'react-redux'
import { getCityData, getCountryData, getProfileData, getStateData } from '../../../Redux/action/MasterAction';
import Beatloader from '../../../Common/BeatLoader';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { db } from '../../firbase';
import { doc, updateDoc } from "firebase/firestore";

// Crop imports - sirf ye do lines add karni hain
import CropModal from '../../../utils/ImageCropModal';
import getCroppedImg from '../../../utils/cropImage';

const host = process.env.REACT_APP_API_SERVER
const TutorProfilePersonalInfo = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [filePreview, setFilePreview] = useState(null);
    const authToken = localStorage.getItem('tutor-token');

    // Crop states - ye teen lines add karni hain
    const [isCropModalOpen, setIsCropModalOpen] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [originalFile, setOriginalFile] = useState(null);

    useEffect(() => {
        dispatch(getProfileData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

        //country
        loadingCountryDataListApi,
        CountryDataListApiData,
        CountryDataListApiError,

        //state
        loadingStateDataListApi,
        StateDataListApiData,
        StateDataListApiError,

        //city
        loadingCityDataListApi,
        CityDataListApiData,
        CityDataListApiError,
    } = useSelector(state => state?.MasterReducer);


    useEffect(() => {

        dispatch(getCountryData());
    }, []);







    let [initialValues, setInitialValues] = useState({

        name: "",
        lastName: "",
        country_code: "",
        mobile: "",
        email: "",
        dob: "",
        gender: "",
        password: "",
        cpassword: "",
        about_the_tutor: "",
        country_id: "",
        state_id: "",
        city_id: "",
        address_line_1: "",
        address_line_2: "",
        zip_code: "",
        user_type: "",
        profile_image: "",
        tutoring_location: "",
        about_the_tutor: "",
        language: "",
        specialization: "",
        qualifications: "",
        experience: "",
        per_session_price_one_to_one: "",
        per_session_price_group: "",



    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            name: Yup.string().required("Name is required").matches(/^[a-zA-Z .]+$/, "Name can only contain letters."),
            email: Yup.string().required("Email is required.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/, "Enter a valid E-mail"),
            mobile: Yup.string().required("Phone is required")
                .matches(/^[1-9][0-9]{7,14}$/, "Please enter a valid Mobile Number."),
            country_id: Yup.string().required("Country is required"),
            gender: Yup.string().required("Gender is required"),
            dob: Yup.date()
                .max(new Date(), 'Date of birth cannot be in the future')
                .test('is-at-least-18', 'Must be at least 18 years old', function (value) {
                    const today = new Date();
                    const userBirthDate = new Date(value);
                    const age = today.getFullYear() - userBirthDate.getFullYear();
                    return age >= 18;
                })
                .required('Please select date of birth.'),
            experience: Yup.string()
                .required('Experience is required')
                .test('experience-matches-dob', 'Experience does not align with date of birth', function (experience) {
                    const { dob } = this.parent; // Access DOB from the parent context
                    if (!dob) return true; // Skip validation if DOB is not provided
                    const birthDate = new Date(dob);
                    const today = new Date();
                    const age = today.getFullYear() - birthDate.getFullYear();
                    const calculatedExperience = age - 18; // Minimum age to start working
                    return parseInt(experience, 10) <= calculatedExperience;
                }),
            country_id: Yup.string().required("Country is required"),
            state_id: Yup.string().required("State is required"),
            city_id: Yup.string().required("City is required"),
            address_line_1: Yup.string().required("Address line 1 is required"),
            zip_code: Yup.string().required("Zip code is required").matches(/^[0-9]+$/, "Please enter a valid Zip Code."),
            about_the_tutor: Yup.string().required("About the tutor is required"),
            tutoring_location: Yup.string().required("Tutoring in location is required"),
            language: Yup.string().required("Instructor language is required"),
            specialization: Yup.string().required("Specialization is required"),
            qualifications: Yup.string().required("Qualifications is required"),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {

                setSubmitting(true);
                let config = {
                    headers: {

                        'Content-Type': 'multipart/form-data',
                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                };
                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("email", values.email)
                formData.append("country_code", values.country_code)
                formData.append("mobile", values.mobile)
                formData.append("dob", values.dob)
                formData.append("gender", values.gender)
                formData.append("country_id", values.country_id)
                formData.append("state_id", values.state_id)
                formData.append("city_id", values.city_id)
                formData.append("address_line_1", values.address_line_1)
                formData.append("address_line_2", values.address_line_2)
                formData.append("zip_code", values.zip_code)
                formData.append("user_type", values.user_type)
                formData.append("profile_image", values.profile_image)
                formData.append("tutoring_location", values.tutoring_location)
                formData.append("language", values.language)
                formData.append("about_the_tutor", values.about_the_tutor)
                formData.append("specialization", values.specialization)
                formData.append("experience", values.experience)
                formData.append("qualifications", values.qualifications)
                formData.append("per_session_price_one_to_one", values.per_session_price_one_to_one)
                formData.append("per_session_price_group", values.per_session_price_group)


                const response = await axios.post(`${host}/api/tutor/create-basic-details`, formData, config)

                if (response.status === 200) {
                    toast.success('Personal details updated successfully');
                    setSubmitting(false);
                    setFilePreview(null);

                    // Dispatch profile data update
                    dispatch(getProfileData(authToken));

                    // Decode token and update user status in Firestore
                    const decoded = jwtDecode(authToken);
                    const id = decoded?.user?.user_firebase_id;

                    await updateDoc(doc(db, "users", id), {
                        name: values.name,
                    });

                    // Navigate to profile settings
                    navigate('/tutor/profile-settings');
                } else {

                    toast.error(response.data.message);
                    setSubmitting(false);
                }

            }
            catch (error) {

                toast.error(error.response.data.message);

                setSubmitting(false);

            }

        }
    });


    useEffect(() => {

        if (ProfileDataListApiData?.data) {
            formik.setValues({
                name: ProfileDataListApiData?.data?.name ?? "",
                email: ProfileDataListApiData?.data?.email ?? "",
                country_code: ProfileDataListApiData?.data?.country_code ?? "",
                mobile: ProfileDataListApiData?.data?.mobile ?? "",
                dob: ProfileDataListApiData?.data?.dob ?? "",
                gender: ProfileDataListApiData?.data?.gender ?? "",
                country_id: ProfileDataListApiData?.data?.country_id ?? "",
                state_id: ProfileDataListApiData?.data?.state_id ?? "",
                city_id: ProfileDataListApiData?.data?.city_id ?? "",
                address_line_1: ProfileDataListApiData?.data?.address_line_1 ?? "",
                address_line_2: ProfileDataListApiData?.data?.address_line_2 ?? "",
                zip_code: ProfileDataListApiData?.data?.zip_code ?? "",
                profile_image: ProfileDataListApiData?.data?.profile_img ?? "",
                user_type: ProfileDataListApiData?.data?.user_type ?? "",
                language: ProfileDataListApiData?.data?.tutordetails?.language ?? "",
                about_the_tutor: ProfileDataListApiData?.data?.tutordetails?.about_the_tutor ?? "",
                tutoring_location: ProfileDataListApiData?.data?.tutordetails?.tutoring_location ?? "",
                specialization: ProfileDataListApiData?.data?.tutordetails?.specialization ?? "",
                experience: ProfileDataListApiData?.data?.tutordetails?.experience ?? "",
                qualifications: ProfileDataListApiData?.data?.tutordetails?.qualifications ?? "",
                per_session_price_one_to_one: ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one ?? "",
                per_session_price_group: ProfileDataListApiData?.data?.tutordetails?.per_session_price_group ?? "",

            })

        }
    }, [ProfileDataListApiData?.data])
    useEffect(() => {
        dispatch(getStateData(formik.values.country_id))
    }, [formik.values.country_id])

    useEffect(() => {
        dispatch(getCityData(formik.values.state_id))
    }, [formik.values.state_id])



    const handleGroupFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Original file store karo
            setOriginalFile(file);


            const previewUrl = URL.createObjectURL(file);
            setImageToCrop(previewUrl);
            setIsCropModalOpen(true);


            e.target.value = "";
        }
    };

    // Ye naya function add karna hai
    const handleCropComplete = useCallback(async (croppedBlob, croppedFileUrl) => {
        try {
            // Blob ko File mein convert karo
            const croppedFile = new File([croppedBlob], "profile-image.jpg", {
                type: "image/jpeg"
            });


            formik.setFieldValue('profile_image', croppedFile);


            setFilePreview(croppedFileUrl);


            setIsCropModalOpen(false);
            setImageToCrop(null);

        } catch (error) {
            console.error('Error cropping image:', error);
            toast.error('Failed to crop image');
        }
    }, [formik]);


    const handleCropCancel = useCallback(() => {
        setIsCropModalOpen(false);
        setImageToCrop(null);
        setOriginalFile(null);


        if (filePreview && filePreview !== `${host}${ProfileDataListApiData?.data?.profile_img}`) {
            URL.revokeObjectURL(filePreview);
        }
        setFilePreview(null);
    }, [filePreview, ProfileDataListApiData]);

    const handleCountryChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('state_id', '')
        formik.setFieldValue('city_id', '')

        if (id == '') {
            dispatch(getStateData('0'))
        }
        else {
            dispatch(getStateData(id))
        }
        dispatch(getCityData(0))
    }

    const handleStateChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('city_id', '')
        if (id == '') {
            dispatch(getCityData('0'))
        }
        else {
            dispatch(getCityData(id))
        }
    }


    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">

                            <main className="px-3 py-4">
                                <div className="student-profile-sec px-3">
                                    <div className="row mb-5">


                                    </div>
                                </div>
                                <ul className="nav nav-tabs tutor-profile-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="personal-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#personal"
                                            type="button"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="false"
                                        >
                                            <i className="fa-regular fa-user" /> Personal Information
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="bank-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#bank"
                                            type="button"
                                            role="tab"
                                            aria-controls="bank"
                                            aria-selected="true"
                                        >
                                            <i className="fa-solid fa-building-columns" /> Bank Details
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="price-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#price"
                                            type="button"
                                            role="tab"
                                            aria-controls="price"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-tag" /> Updated Tutoring Price
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="tutor-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#tutor"
                                            type="button"
                                            role="tab"
                                            aria-controls="tutor"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-vcard-fill" /> Tutor Teaching List
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="cip-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#cip"
                                            type="button"
                                            role="tab"
                                            aria-controls="cip"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-fill-check" /> CIP Details
                                        </button>
                                    </li>
                                </ul>
                                <div
                                    className="tab-content"
                                    id="myTabContent"
                                    style={{ backgroundColor: "aliceblue" }}
                                >
                                    {/* Personal Information */}

                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade show active p-3"
                                        id="personal"
                                        role="tabpanel"
                                        aria-labelledby="personal-tab"
                                    >
                                        {loadingProfileDataListApi ?
                                            <Beatloader />
                                            :
                                            <form onSubmit={formik.handleSubmit} method='post'>
                                                <div className="d-flex justify-content-between my-4">
                                                    <h5>Personal Information</h5>
                                                    {/* <Link
                                                    to="/tutor/profile-settings-personal-info"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link> */}
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center pt-5">
                                                        <div className="profile-top-sec w-50">
                                                            <div className="profile-top-img d-flex justify-content-center">
                                                                <OverlayTrigger

                                                                    placement='right'
                                                                    overlay={
                                                                        <Tooltip className='bg-light'>
                                                                            {ProfileDataListApiData?.profile_status_percentage ?? 0}%
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="img-sec position-relative">
                                                                        {/* Circular Progress Bar */}
                                                                        <AnimatedProgressProvider
                                                                            valueStart={0}
                                                                            valueEnd={ProfileDataListApiData?.profile_status_percentage ?? 0}
                                                                            duration={1.4}
                                                                            easingFunction={easeQuadInOut}

                                                                        >
                                                                            {value => {
                                                                                const roundedValue = Math.round(value);
                                                                                return (
                                                                                    <CircularProgressbar
                                                                                        value={value}

                                                                                        /* This is important to include, because if you're fully managing the
                                                                                  animation yourself, you'll want to disable the CSS animation. */
                                                                                        styles={buildStyles({ pathTransition: "none" })}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        </AnimatedProgressProvider>
                                                                        {/* Profile Image */}
                                                                        <div className='d-flex justify-content-end w-100 flex-wrap'>
                                                                            {!ProfileDataListApiData?.data?.profile_img && (
                                                                                <img
                                                                                    className='upload-image-style'
                                                                                    title='Upload Profile Image'
                                                                                    width={100}
                                                                                    src='/assets/img/user/upload.png'
                                                                                    onClick={() => document.getElementById("uploadVideo").click()}
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            )}
                                                                            <input
                                                                                id="uploadVideo"
                                                                                type="file"
                                                                                accept="image/*"
                                                                                name="profile_image"
                                                                                style={{ display: "none" }} // Hide the input
                                                                                onChange={(e) => {
                                                                                    handleGroupFileChange(e);
                                                                                    // e.target.value = ""; 
                                                                                }}
                                                                                onBlur={formik.handleBlur}
                                                                            />

                                                                            <label htmlFor="uploadVideo">
                                                                                <img
                                                                                    src={filePreview ? filePreview : `${host}${ProfileDataListApiData?.data?.profile_img}`}
                                                                                    onClick={() => document.getElementById("uploadVideo").click()}
                                                                                    onError={(e) => {
                                                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                                    }}
                                                                                    className="profile-img"
                                                                                    style={{ cursor: 'pointer' }}
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </div>
                                                            {/* <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4> */}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Full Name<span className='text-danger'>*</span></label>
                                                        <input
                                                            maxLength={20}
                                                            type="text"
                                                            placeholder="Enter your name"
                                                            className="input-form"
                                                            name='name'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.name && formik.errors.name ? (
                                                                <div className='text-danger'>{formik.errors.name}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 row">
                                                        <label htmlFor="">Phone Number<span className='text-danger'>*</span></label>


                                                        <div className="col-lg-4 border-end">
                                                            {/* <select className='form-select' name='country_code' onChange={(e) => {
                                                                formik.handleChange(e);

                                                            }}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.country_code}>
                                                                <option value=""> --Select Country--</option>
                                                                {CountryDataListApiData?.map((data) => (
                                                                    <option value={data?.phone_code}>{data?.sort_name} ({data?.phone_code})</option>
                                                                ))}

                                                            </select> */}
                                                            <select
                                                                className='form-select'
                                                                name='country_code'
                                                                onChange={(e) => {

                                                                    const selectedCountry = CountryDataListApiData?.find(
                                                                        (item) => item.id == e.target.value
                                                                    );

                                                                    formik.setFieldValue(
                                                                        "country_id",
                                                                        selectedCountry?.id
                                                                    );

                                                                    formik.setFieldValue(
                                                                        "country_code",
                                                                        selectedCountry?.phone_code
                                                                    );

                                                                }}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.country_id}
                                                            >
                                                                <option value=""> --Select Country--</option>

                                                                {CountryDataListApiData?.map((data) => (
                                                                    <option
                                                                        key={data.id}
                                                                        value={data.id}
                                                                    >
                                                                        {data.name} ({data.phone_code})
                                                                    </option>
                                                                ))}

                                                            </select>
                                                        </div>
                                                        <div className="col-lg-8">
                                                            <input
                                                                maxLength={10}
                                                                type="mobile"
                                                                placeholder="Enter your mobile"
                                                                className="input-form"
                                                                name='mobile'
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.mobile}
                                                            />
                                                        </div>


                                                        {/* <PhoneInput
                                                    limitMaxLength={15}
                                                    id="mobile"
                                                    className="input-form"
                                                    placeholder="Enter your phone number"
                                                    defaultCountry="IN"
                                                    name="mobile"
                                                    value={phone} // Bind tutorformik's value to PhoneInput
                                                    onChange={(value) => { handlePhoneClick(value); }} // Update tutorformik's value
                                                /> */}
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.mobile && formik.errors.mobile ? (
                                                                <div className='text-danger'>{formik.errors.mobile}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Email Id<span className='text-danger'>*</span></label>
                                                        <input
                                                            maxLength={100}
                                                            type="email"
                                                            placeholder="Enter your email"
                                                            className="input-form"
                                                            name='email'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.email}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.email && formik.errors.email ? (
                                                                <div className='text-danger'>{formik.errors.email}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Date of Birth<span className='text-danger'>*</span></label>
                                                        <input type="date" className="input-form" name='dob'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.dob}
                                                            max={new Date().toISOString().split("T")[0]}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.dob && formik.errors.dob ? (
                                                                <div className='text-danger'>{formik.errors.dob}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Gender<span className='text-danger'>*</span></label>
                                                        <select name="gender" id="gender"

                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.gender}>
                                                            <option value=''>-Select-</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.gender && formik.errors.gender ? (
                                                                <div className='text-danger'>{formik.errors.gender}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Address Line-1<span className='text-danger'>*</span></label>
                                                        <input
                                                            maxLength={100}
                                                            type="text"
                                                            placeholder="Enter your address line-1"
                                                            className="input-form"
                                                            name='address_line_1'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.address_line_1}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.address_line_1 && formik.errors.address_line_1 ? (
                                                                <div className='text-danger'>{formik.errors.address_line_1}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Address Line-2</label>
                                                        <input
                                                            maxLength={100}
                                                            type="text"
                                                            placeholder="Enter your address line-2"
                                                            className="input-form"
                                                            name='address_line_2'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.address_line_2}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.address_line_2 && formik.errors.address_line_2 ? (
                                                                <div className='text-danger'>{formik.errors.address_line_2}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Country<span className='text-danger'>*</span></label>
                                                        <select name='country_id' onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleCountryChange(e)
                                                        }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.country_id}>
                                                            <option value=""> --Select Country--</option>
                                                            {CountryDataListApiData?.map((data) => (
                                                                <option value={data?.id}>{data?.name}</option>
                                                            ))}

                                                        </select>
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.country_id && formik.errors.country_id ? (
                                                                <div className='text-danger'>{formik.errors.country_id}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">State<span className='text-danger'>*</span></label>
                                                        <select name='state_id' onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleStateChange(e)
                                                        }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.state_id}>

                                                            <option selected="" disabled="" value="">
                                                                --Select State--
                                                            </option>
                                                            {StateDataListApiData?.map((data) => (
                                                                <option value={data?.id}>{data?.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.state_id && formik.errors.state_id ? (
                                                                <div className='text-danger'>{formik.errors.state_id}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">City<span className='text-danger'>*</span></label>
                                                        <select name="city_id" id="city"

                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.city_id}>
                                                            <option selected="" disabled="" value="">
                                                                --Select City--
                                                            </option>
                                                            {CityDataListApiData?.map((data) => (
                                                                <option value={data?.id}>{data?.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.city_id && formik.errors.city_id ? (
                                                                <div className='text-danger'>{formik.errors.city_id}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <label htmlFor="">Zip code<span className='text-danger'>*</span></label>
                                                        <input
                                                            type="number"
                                                            placeholder="Enter zip code"
                                                            className="input-form"
                                                            name='zip_code'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.zip_code}
                                                            maxLength={6}
                                                            minLength={4}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.zip_code && formik.errors.zip_code ? (
                                                                <div className='text-danger'>{formik.errors.zip_code}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                                        <label
                                                            htmlFor="exampleFormControlInput1"
                                                            className="form-label"
                                                        >
                                                            Qualification<span className='text-danger'>*</span>
                                                        </label>
                                                        <input
                                                            maxLength={20}
                                                            type="text"
                                                            className="input-form"
                                                            id="exampleFormControlInput1"
                                                            placeholder="Enter your qualification"
                                                            name='qualifications'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.qualifications}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.qualifications && formik.errors.qualifications ? (
                                                                <div className='text-danger'>{formik.errors.qualifications}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                                                        <label
                                                            htmlFor="exampleFormControlInput1"
                                                            className="form-label"
                                                        >
                                                            Specialization
                                                            <span className='text-danger'>*</span></label>
                                                        <input
                                                            maxLength={20}
                                                            type="text"
                                                            className="input-form"
                                                            id="exampleFormControlInput1"
                                                            placeholder="Enter your specialization"
                                                            name='specialization'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.specialization}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.specialization && formik.errors.specialization ? (
                                                                <div className='text-danger'>{formik.errors.specialization}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Experience in years
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <input
                                                            type="number"

                                                            className="input-form w-100"
                                                            name='experience'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.experience}
                                                            maxLength={2}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.experience && formik.errors.experience ? (
                                                                <div className='text-danger'>{formik.errors.experience}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Tutoring location
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            maxLength={100}
                                                            className="input-form w-100"
                                                            name='tutoring_location'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.tutoring_location}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.tutoring_location && formik.errors.tutoring_location ? (
                                                                <div className='text-danger'>{formik.errors.tutoring_location}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Instructor Language
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            maxLength={20}
                                                            className="input-form w-100"
                                                            name='language'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.language}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.language && formik.errors.language ? (
                                                                <div className='text-danger'>{formik.errors.language}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Session Price One to Oneaaa(in dollars)
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>

                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Session Price Group(in dollars)
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                                    </div> */}
                                                    <div className="col-lg-12 col-md-12">
                                                        <label htmlFor="" className="label">
                                                            About the tutor
                                                            <span className='text-danger'>*</span></label>
                                                        <br />
                                                        <textarea
                                                            className="input-form"
                                                            id="exampleFormControlInput1"
                                                            placeholder="Enter about the Tutor"

                                                            defaultValue={
                                                                "                                                                    "
                                                            }
                                                            name='about_the_tutor'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.about_the_tutor}
                                                        />
                                                        <div className="help-block with-errors mb-2">
                                                            {formik.touched.about_the_tutor && formik.errors.about_the_tutor ? (
                                                                <div className='text-danger'>{formik.errors.about_the_tutor}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-3 col-md-12">
                                                        <input
                                                            disabled={formik.isSubmitting}
                                                            type="submit"
                                                            defaultValue="Submit"
                                                            className="btn btn-primary input-form-submit submit-btn w-100"
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        } </div>
                                    {/* Bank Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="bank"
                                        role="tabpanel"
                                        aria-labelledby="bank-tab"
                                    >
                                        <form>
                                            <div className="d-flex justify-content-between my-4">
                                                <h5>Bank Details</h5>
                                                <Link
                                                    to="/tutor/profile-settings-bank-details"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Account Holder <span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.account_holder}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Account Number<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.account_number}</p>
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        SWIFT/BIC Code<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.wire_transfer_no}</p>
                                                </div>
                                                {/* <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        SWIFT/BIC Code<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.bank_code}</p>
                                                </div> */}
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="" className="label">
                                                        Routing Number(ACH or ABA)<span className='text-danger'>*</span>
                                                    </label>
                                                    <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutorbankdetails?.routing_no}</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* Updated Tutoring Price */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="price"
                                        role="tabpanel"
                                        aria-labelledby="price-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Updated Tutoring Price</h5>
                                            <Link
                                                to="/tutor/profile-settings-updated-tutoring-price"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price One To One<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price Group<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Tutor Teaching List */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="tutor"
                                        role="tabpanel"
                                        aria-labelledby="tutor-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Tutor Teaching List</h5>
                                            <Link
                                                to="/tutor/profile-settings-tutor-teaching-list"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            {ProfileDataListApiData?.data?.tutorteachingdetails?.map((data) => (
                                                <div className="col-lg-6 col-md-6 mb-4">
                                                    <div className="tutor-teaching-list">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 d-flex align-item-center flex-wrap">
                                                                <div
                                                                    className="initial-circle"
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        color: '#333',
                                                                        fontSize: '24px',
                                                                        fontWeight: 'bold',
                                                                        borderRadius: '50%',
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        textTransform: 'uppercase',
                                                                    }}
                                                                >
                                                                    {data?.sub_category?.name?.charAt(0) || '-'}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-5 pt-3">
                                                                <h6 className=" tutor-teaching-list-h6">{data?.category?.other_name ? data?.category?.other_name : data?.category?.name}</h6>
                                                                <p className=" tutor-teaching-list-eco mt-1">{data?.sub_category?.other_name ? data?.sub_category?.other_name : data?.sub_category?.name}</p>
                                                                <p className=" tutor-teaching-list-group ">{data?.teaching_type_id ? 'Group' : 'One To One'}</p>
                                                            </div>
                                                            <div className="col-lg-3 col-md-4">
                                                                <p className=" tutor-teaching-list-approve">{data?.status}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    id="submit-btn-four"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <button
                                                    type="button"
                                                    id="add-btn"
                                                    className="btn btn-primary w-100"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    style={{ display: "none" }}
                                                >
                                                    <i className="fa-solid fa-plus" />
                                                    &nbsp;Add
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Cip Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="cip"
                                        role="tabpanel"
                                        aria-labelledby="cip-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>CIP (Customer Identification Program)</h5>
                                            <Link
                                                to="/tutor/profile-settings-cip"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload educational document image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload certificate image</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.certification &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.certification}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload any valid Govt ID proof</h5>

                                                    {ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document &&
                                                        <div className="image-preview" id="imagePreview">
                                                            <img
                                                                id="preview"
                                                                width={100}
                                                                src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document}`}

                                                                onError={(e) => {
                                                                    e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                                }}
                                                                alt="Image Preview"

                                                            />
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    id="submit-btn-five"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>


            <CropModal
                isOpen={isCropModalOpen}
                imageSrc={imageToCrop}
                onCancel={handleCropCancel}
                onCropComplete={handleCropComplete}
            />

        </div>
    )
}

export default TutorProfilePersonalInfo